export const Selectors = {
  testimonialsWrap: '.testimonials-wrap',
  testimonial: '.testimonial',
  thumbnails: '.testimonials-thumbnails',
  thumbnail: '.testimonials-thumbnail'
};
